import { render, staticRenderFns } from "./ResetTaskModal.vue?vue&type=template&id=2d092631&"
import script from "./ResetTaskModal.vue?vue&type=script&lang=js&"
export * from "./ResetTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports